export const LOAD_API_USER_SUCCESS = 'LOAD_API_USER_SUCCESS';
export const LOAD_YEARLY_OVERVIEW_SUCCESS = 'LOAD_YEARLY_OVERVIEW_SUCCESS';